import { createFileRoute } from "@tanstack/react-router";
import {
	formTabSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/full/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.assetTypeId,
			to: "/admin/configuration/assetTypes/$assetTypeId/full",
			params: { assetTypeId: params.assetTypeId },
			search: formTabSearch(search),
		});
	},
	component: () => null,
});
